<template>
  <div class="payment-stripe-form">
    <el-row type="flex" justify="space-between">
      <h1 class="title">{{ $t('plan_payment.payment_method.title') }}</h1>
      <img src="@/assets/images/card-icons.svg" alt=""/>
    </el-row>
    <el-row type="flex" style="flex-direction: column">
      <el-radio
        v-model="paymentMethodId"
        v-for="method in paymentMethods"
        :label="method.id"
        :key="method.id"
        size="medium"
      >
        {{ method.brand.toUpperCase() }} **** {{ method.last4 }}
      </el-radio>
      <el-radio v-model="paymentMethodId" label="new">{{ $t('plan_payment.payment_method.add_a_new_card') }}</el-radio>
    </el-row>
    <el-row v-show="paymentMethodId == 'new'">
      <div class="stripe">
        <!--<el-row>
          <p>Card holder name</p>
        </el-row>
        <el-row>
          <el-input v-model="name" placeholder="John Doe" />
        </el-row>-->
        <el-row>
          <p>{{ $t('plan_payment.payment_method.card_details') }}</p>
        </el-row>
        <el-row>
          <stripe-element-card
            ref="elementRef"
            :pk="publishableKey"
            :hide-postal-code="true"
            @token="stripeTokenCreated"
            @error="stripeError"
          />
        </el-row>
      </div>
    </el-row>
  </div>
</template>

<script>
  import { StripeElementCard } from '@vue-stripe/vue-stripe';
  import { successMessage, warningMessage } from '@/utils/messages';

  export default {
    props: ['product'],
    components: {
      StripeElementCard
    },
    data () {
      return {
        token: null,
        publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
        config: {
          headers: {
            'store': 'stripe',
            'x-session-token': localStorage.getItem('payment-token'),
            'x-org-token': Buffer.from(`${this.$store.state.organization.currentOrganizationId} ${Date.now()}`).toString('base64'),
          }
        },
        paymentMethods: [],
        paymentMethodId: 'new',
        payment: {
          quantity: 5,
          product_id: undefined,
          order_id: undefined
        },
        waitingInterval: undefined,
        waiting: 0,
        cleanQueryParam: false
      };
    },
    methods: {
      submit () {
        if (this.paymentMethodId === 'new') {
          this.$refs.elementRef.submit();
        } else {
          this.processPayment({ payment_method_id: this.paymentMethodId });
        }
      },
      stripeTokenCreated (token) {
        this.processPayment({ token: token.id });
      },
      stripeError (err) {
        // console.error(err)
        this.$emit('set-loading', false);
      },
      async getPaymentMethods () {
        try {
          const { data } = await this.$axios.get(process.env.VUE_APP_PAYMENT_URL + '/organization/payment-methods', this.config);
          this.paymentMethods = data;
          this.paymentMethodId = data[0]['id'];
        } catch (e) {
          // console.error(e);
          this.$emit('set-loading', false);
        }
      },
      async createOrder () {
        /*
          @example: {
            "organization_id": 123,
            "user_id": "",
            "package": "one_year.8percent.stripe.b2c.v1_membership",
            "quantity": 51,
            "product": "CgEtBQY9XS4mCjoQLS8lA0YeBxMsDRkgCCJlOQQO",
            "currency": "USD",
            "price": 52.49,
            "saving": 229.5
          }
        */
        const userId = this.$store.getters['user/getUserId'];
        const data = Object.assign({ user_id: userId, organization_id: this.organizationId }, this.product);
        try {
          const payment = await this.$axios.post('/v2/checkouts/payment', data);
          this.payment = Object.assign({}, payment.data, {
            product_id: this.product.product,
            quantity: this.product.quantity,
            return_url: window.location.href
          });
        } catch (e) {
          if (e.response) {
            const msg = e.response.data;
            warningMessage(msg, 'elsa-message warning', {
              showClose: false,
              duration: 5000
            })(this);
          }
          this.$emit('set-loading', false);
        }
      },
      async processPayment (token) {
        if (this.payment.order_id === undefined) {
          await this.createOrder()
        }
        /*
          @example
          {
            "token": "tok_1K9OlXFCHl1SIGfYHCwjPnqs",
            "order_id": 228,
            "product_id": "CgEtBQY9XS4mCjoQLS8lA0YeBxMsDRkgCCJlOQQO",
            "quantity": 51,
            "return_url": "http://checkout-stag.elsanow.co"
          }
        */
        await this.$recaptchaLoaded()
        const recaptchaToken = await this.$recaptcha('subscription')
        const verify = {
          version: '3',
          checksum: recaptchaToken,
        }
        const payload = Object.assign({ verify }, token, this.payment);
        const payment_url = process.env.VUE_APP_PAYMENT_URL + (this.product.interval != 'lifetime' ? '/organization/subscription' : '/organization/payment');
        try {
          const resp = await this.$axios.post(payment_url, payload, this.config);
          if (resp.data.status === 'pending' && resp.data.verify) {
            window.location.href = resp.data.verify;
          } else {
            this.waiting = 0;
            this.waitingInterval = setInterval(async () => {
              await this.getPaymentDetail(resp.data.id);
            }, 5000);
          }
        } catch (e) {
          if (e.response) {
            const { detail } = e.response.data;
            warningMessage(detail, 'elsa-message warning', {
              showClose: false,
              duration: 5000
            })(this);
          }
          // this.syncHubSpot()
          this.$emit('set-loading', false);
        }
      },
      async getPaymentDetail (payment_id) {
        const payment_url = process.env.VUE_APP_PAYMENT_URL + (this.product.interval != 'lifetime' ? '/organization/subscription/' : '/organization/payment/');
        try {
          const resp = await this.$axios.get(payment_url + payment_id, this.config);
          if (resp.data.status === 'active' || resp.data.status === 'succeeded') {
            successMessage(this.$t('plan_payment.payment_method.success_msg'),
              'elsa-message success', {
                showClose: false,
                duration: 5000
              })(this);
            this.clearWaiting();
            await this.$router.push(`/admin/organization/${this.organizationId}/plan`);
          } else if (resp.data.status === 'inactive' || resp.data.status === 'failed') {
            this.handleFailed();
          }
          this.waiting += 1;
          if (this.waiting > 5) {
            this.handleFailed();
          }
        } catch (e) {
          if (e.response) {
            const { detail } = e.response.data;
            warningMessage(detail, 'elsa-message warning', {
              showClose: false,
              duration: 5000
            })(this);
          }
          // this.syncHubSpot()
          this.clearWaiting();
        }
      },
      clearWaiting () {
        this.waiting = 0;
        clearInterval(this.waitingInterval);
        this.$emit('set-loading', false);
      },
      handleFailed () {
        warningMessage(this.$t('plan_payment.payment_method.failed_msg'), 'elsa-message warning', {
          showClose: false,
          duration: 5000
        })(this);
        this.clearWaiting();
        if (this.cleanQueryParam) {
          this.$router.push(this.$route.path);
        }
      }
    },
    mounted () {
      this.getPaymentMethods();
      if (this.$route.query.order_id && this.$route.query.id) {
        this.$emit('set-loading', true);
        this.waiting = 0;
        this.waitingInterval = setInterval(async () => {
          await this.getPaymentDetail(this.$route.query.id);
        }, 10000);
        this.cleanQueryParam = true
      }
    },
    computed: {
      organizationId () {
        return this.$store.state.organization.currentOrganizationId;
      },
    },
  };
</script>

<style lang="scss" scoped>
  ::v-deep .btn-custom {
    span {
      display: flex;
      align-items: center;
    }

    img {
      margin-right: 12px;
    }
  }

  ::v-deep .el-radio {
    margin-top: 30px;
  }

  p {
    font-size: 18px;
  }

  .title {
    font-size: 24px;
    line-height: 120%;
    font-weight: bold;
    color: #333333;
    letter-spacing: unset;
  }

  ::v-deep .el-input__inner {
    border: 1px solid rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    border-radius: 55px;
    font-size: 16px;
  }

  .stripe {
    margin-top: 15px;
    margin-left: 30px;
  }

  ::v-deep #stripe-element-form {
    #stripe-element-mount-point {
      border: 1px solid rgba(0, 0, 0, 0.2);
      box-sizing: border-box;
      border-radius: 55px;
      box-shadow: unset !important;
    }
    #stripe-element-errors {
      color: red;
      margin-top: 20px;
    }
  }

  ::v-deep .el-radio__inner {
    width: 24px;
    height: 24px;
  }

  ::v-deep .el-radio__inner::after {
    box-sizing: content-box;
    content: "";
    border: 2px solid #fff;
    border-left: 0;
    border-top: 0;
    position: absolute;
    height: 10px;
    width: 4px;
    left: 35%;
    top: 15%;
    transition: transform .15s ease-in .05s;
    transform-origin: center;
    border-radius: unset;
    background-color: unset;
  }

  ::v-deep .el-radio__input.is-checked .el-radio__inner::after {
    transform: rotate(45deg) scaleY(1) !important;
  }

  ::v-deep .el-radio__label {
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    letter-spacing: 0.2px;
    color: #333333 !important;
  }

</style>
